




























import Vue from "vue";

interface Props {
  // All centered flexbox which fill the available parent space
  containerFlexCenter?: boolean;
  column?: boolean;
  fill?: boolean;
  // Fill parent's available space
  // TODO: replace it with fill?
  fillParent?: boolean;
  flex?: boolean;
  // override flex and provide a vertically and horizontally centered container
  flexCenter?: boolean;
  // As-of May 2020, duplicate of `fill`
  flexFill?: boolean;
  overflowAuto?: boolean;
  overflowXAuto?: boolean;
  overflowYAuto?: boolean;
  row?: boolean;
}

export default Vue.extend<Props>({
  name: "JzContainer",
  functional: true,
  props: {
    containerFlexCenter: { type: Boolean, default: false },
    column: { type: Boolean, default: false },
    fill: { type: Boolean, default: false },
    fillParent: { type: Boolean, default: false },
    flex: { type: Boolean, default: false },
    flexCenter: { type: Boolean, default: false },
    flexFill: { type: Boolean, default: false },
    overflowAuto: { type: Boolean, default: false },
    overflowXAuto: { type: Boolean, default: false },
    overflowYAuto: { type: Boolean, default: false },
    row: { type: Boolean, default: false }
  }
});
